// extracted by mini-css-extract-plugin
export default {"selectAll":"AssignExercise_selectAll__CNHWf"};